import {NgModule} from '@angular/core';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';

import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';

// import { Facebook, FacebookLoginResponse } from '@awesome-cordova-plugins/facebook/ngx';
//import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics/ngx';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';

@NgModule({
  providers: [
   
    Diagnostic,
    // Facebook,
    //GoogleAnalytics,
    ScreenOrientation,
    Geolocation ,
    
  ]
})
export class NativeModule {
}
